import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import _ from "lodash";
import styled from "styled-components";

import { NotFoundWrapper } from "components/pages/dormitories-page";
import PaginationControl from "components/tools/pagination-control";
import { Control } from "components/ui-kit/control";
import {
    Breadcrumb,
    Button,
    Container,
    Form,
    Frame,
    Row,
    RowWrapper,
    TExtra
} from "components/ui-kit/styled-templates";

import LabsApi from "api/labs-api";
import UniversityApi from "api/university-api";

import useBodyBackground from "hooks/useBodyBackground";
import useFormControl from "hooks/useFormControl";
import usePagination from "hooks/usePagination";
import { useStorageListener } from "hooks/useStorage";

import { EForms } from "types/enums";
import Select from "react-select";

const dormitoriesStub = new Array(54).fill({});

const interferance = (path: string, value: any) => (i: any) => _.get(i, path)?.includes?.(value ?? ``);
const arrayToOptions = (i: any) => ({ value: i, label: i });

const LabsSearchPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    let isRu = i18n.language === "ru";

    useBodyBackground(`white`);

    const universities = useStorageListener(`universities`, {});

    const labs = useStorageListener(`labs`, {});

    const { data, clearForm, setValues } = useFormControl({ name: EForms.searchFilters });

    console.log("form data = ", data);

    // filteredDormitories = filteredDormitories.filter((x) => (x?.onModeration == false && x?.hideFromAll != true));

    let filteredLabs = _(labs)
        .values()
        .map((lab) => ({ ...lab, university: universities[lab.universityId] }))
        .filter(interferance("university.details.city", data.city))
        .filter(interferance("university.details.region", data.region))
        .filter(interferance("universityId", data.university))
        .sortBy(["details.dates.from"])
        .value();

    // filteredDormitories = filteredDormitories.filter((x) => (x?.onModeration == false && x?.hideFromAll != true));

    filteredLabs = filteredLabs.filter((x) => (x?.hideFromAll != true));

    console.log("-->> filteredLabs = ", filteredLabs);
    if (data?.searchText != undefined && data?.searchText != "") {
        filteredLabs = filteredLabs.filter(x => (x?.details != undefined && x?.details?.name != undefined && (x?.details?.name?.toLowerCase().indexOf(data?.searchText.toLowerCase()) > -1)));
    }

    const filterOptions = {
        city: _(filteredLabs as any)
            .values()
            .map(`university.details.city`)
            .uniq()
            .map(arrayToOptions)
            .sortBy([`label`])
            .value(),
        university: _(filteredLabs as any)
            .values()
            .map("university")
            .uniqBy(`id`)
            .map((i) => ({ label: _.get(i, `details.shortName`, _.get(i, `details.name`, "")), value: i.id }))
            .value(),
        region: _(filteredLabs as any)
            .values()
            .map(`university.details.region`)
            .uniq()
            .map(arrayToOptions)
            .sortBy([`label`])
            .value()
    };

    const paginationResult = usePagination(filteredLabs as any, { perPage: 4 });
    const { visibleItems } = paginationResult;

    useEffect(() => {
        UniversityApi.getAllUniversitiesData();
        LabsApi.getLabs();
    }, []);

    let filteredRegions = (filterOptions?.region || []).sort((a, b) => {
        let s1 = a.value;
        let s2 = b.value;
        if (s1.indexOf('ЕА') > -1){
            s1 = `_${s1}`;
        }
        if (s2.indexOf('ЕА') > -1){
            s2 = `_${s2}`;
        }
        if (s1 > s2) {
            return 1;
        }
        if (s1 < s2) {
            return -1;
        }
        return 0;
    });


    return (
        <Container extra={`align-items: flex-start;`}>
            {/*<Breadcrumb.Wrapper>*/}
            {/*    <Breadcrumb.Item to="/">{t("t5e9y72hvoo")}</Breadcrumb.Item>*/}
            {/*    <Breadcrumb.Item to="/search">{t("labsSearch.title")}</Breadcrumb.Item>*/}
            {/*</Breadcrumb.Wrapper>*/}
            <RowWrapper extra={`h1 { margin: 0; };`}>
                {/*<h1>{t("labsSearch.title")}</h1>*/}
                {/*<h1>{t("labsSearch.title")}</h1>*/}
            </RowWrapper>
            <RowWrapper extra={`margin-top: 56px; flex-wrap: wrap; gap: 32px; align-items: flex-start;`}>
                <FiltersWrapper name={EForms.searchFilters}>
                    <h2>{t("tvryp728hb")}</h2>

                    <Control.Input
                        name="searchText"
                        placeholder={isRu ? "Введите поисковую строку" : "Enter search string" }
                        label={isRu ? "Ключевое слово" : "Keyword"}
                        menuProps={{ extra: `> * { max-width: 250px; }` }}
                    />

                    {/*<Control.Select*/}
                    {/*    name="university"*/}
                    {/*    placeholder={t("slguq6rk4ms")}*/}
                    {/*    label={t("vqy9f871xai")}*/}
                    {/*    options={filterOptions.university}*/}
                    {/*    menuProps={{ extra: `> * { max-width: 250px; }` }}*/}
                    {/*/>*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("vqy9f871xai")}</Label>
                        </div>
                        <Select
                            name="university"
                            placeholder={t("slguq6rk4ms")}
                            options={filterOptions.university}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, university: val });
                            }}
                        />
                    </div>


                    {/*<Control.Select name="region" placeholder={t("sd1hnuvfi3f")} label={t("91parqfw3d")}*/}
                    {/*                options={filteredRegions} />*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("91parqfw3d")}</Label>
                        </div>
                        <Select
                            name="region"
                            placeholder={t("sd1hnuvfi3f")}
                            options={filteredRegions}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, region: val });
                            }}
                        />
                    </div>


                    {/*<Control.Select*/}
                    {/*    name="city"*/}
                    {/*    placeholder={t("ssd650u8gt")}*/}
                    {/*    label={t("q3hf416oqjj")}*/}
                    {/*    options={filterOptions.city}*/}
                    {/*    menuProps={{ extra: `> * { max-width: 250px; }` }}*/}
                    {/*/>*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("q3hf416oqjj")}</Label>
                        </div>
                        <Select
                            name="city"
                            placeholder={t("ssd650u8gt")}
                            options={filterOptions.city}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, city: val });
                            }}
                        />
                    </div>

                    {/* <Control.DateRange name="dateRange" label="Период" /> */}
                    <Row extra={`width: 100%; justify-content: center;`}>
                        <Button variant="outlined" extra="border: 0px;" onClick={clearForm}>
                            {t("wy5yz61f2u")}
                        </Button>
                    </Row>
                </FiltersWrapper>
                <Frame extra={`width: 100%; flex: 1; align-items: flex-start; gap: 15px 0; a { width: 100%; };`}>
                    <h2>
                        {t("3v5uoaamac7")} {paginationResult.totalCount}
                    </h2>
                    {visibleItems.map((item: any, index: number) => {
                        const goTo = (e) => {
                            if (e.target.className.includes("link-ignore")) {
                                return;
                            }
                            navigate(`/lab/${item.id}`);
                        };
                        return (
                            <div key={index} onClick={goTo}>
                                <LabSearchPreview.Component labId={item.id} lab={item}
                                                            university={_.get(universities, item?.universityId)} />
                            </div>
                        );
                    })}
                    {!dormitoriesStub.length && <NotFoundWrapper>{t("hcbz42ae1vn")}</NotFoundWrapper>}
                    <PaginationControl pagination={paginationResult} />
                </Frame>
            </RowWrapper>
        </Container>
    );
};

export const LabSearchPreview = {
    Component: ({ labId, ...props }: any) => {
        const { t } = useTranslation();

        const { lab, university } = props;

        return (
            <LabSearchPreview.Wrapper className="cursor-pointer">
                <h3>{_.get(lab, `details.name`)}</h3>
                <div>{t("5c4ea9b1fzy")}</div>
                <strong>{_.get(university, `details.name`)}</strong>
                <Row className={'science_row_1'} extra="width: 100%; > * { flex: 1; };">
                    <div>
                        <div>{t("labsSearch.item.link")}</div>
                        <a href={_.get(lab, `details.link`)} style={{display: 'block', wordBreak: 'break-all'}} >{_.get(lab, `details.link`)}</a>
                    </div>
                    <div>
                        <div>{t("labsSearch.item.city")}</div>
                        <strong>{_.get(lab, `details.city`)}</strong>
                    </div>
                </Row>
                <div>
                    {_.get(lab, `details.description`, "").slice(0, 100)}
                    {_.get(lab, `details.description`, "").length > 100 ? `...` : ``}
                </div>
                <div className="details">{t("f9hqqxcdpyr")}</div>
            </LabSearchPreview.Wrapper>
        );
    },
    Wrapper: styled(Frame)`
      border: 1px solid ${({ theme }) => theme.halfblue};
      box-sizing: border-box;
      border-radius: 8px;
      overflow: hidden;
      align-items: flex-start;
      padding: 24px 20px;
      box-sizing: border-box;
      /* width: 100%; */
      gap: 15px;

      font-size: 15px;
      line-height: 20px;

      .type {
        color: ${({ theme }) => theme.blue};
        font-weight: 400;
        font-size: 13px;
      }

      .details {
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: ${({ theme }) => theme.blue};
      }

      h3 {
        margin: 0 0 8px 0;
      }

      .uni-name {
        font-family: "Noto Sans", sans-serif;
        font-weight: 600;
        font-size: 18px;
        line-height: 27px;
        color: ${({ theme }) => theme.grey};
      }

      .region {
        font-weight: 400;
        font-size: 13px;
        line-height: 17px;
        color: ${({ theme }) => theme.blue};
      }
    `,
    Photo: styled(Frame)<{ src?: string; extra?: TExtra }>`
      width: 256px;
      height: 322px;
      background: ${({ theme }) => theme.lightblue};
      ${({ src }) => src && `background: url('${src}') no-repeat center center / cover;`}

      ${({ extra }) => extra}
    `,
    TableWrapper: styled(Row)`
      flex-wrap: wrap;
      gap: 16px 8px;
      margin-top: 16px;

      > * {
        align-items: flex-start;
        width: calc(50% - 8px);
        gap: 8px;
        font-size: 15px;
        line-height: 20px;
      }
    `,
    ContentWrapper: styled(Frame)`
      width: 100%;
      align-items: flex-start;
      justify-content: space-between;
      padding: 24px;
      box-sizing: border-box;
      height: 322px;
    `
};

const Label = styled.div`
  color: rgb(33, 33, 33);
  margin-bottom: 8px;
  font-size: 14px;
`;


const FiltersWrapper = styled(Form)`
  width: 373px;
  background: ${({ theme }) => theme.lightblue};
  border-radius: 12px;
  padding: 40px 32px;
  box-sizing: border-box;

  h2 {
    margin: 0 0 15px 0;
  }

  span {
    background: white;
  }
`;

export default LabsSearchPage;
